import { PropsWithChildren } from 'react';

import {
  selectCompSequence,
  selectRentalCompSequence,
} from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { PropertyDataSyncDriver } from './PropertyDataSyncDriver.tsx';
import { useOrderFeaturesSyncDriver } from './useOrderFeaturesSyncDriver.ts';

export const PropertyComparisonGridSyncDriver = ({
  orderID,
  children,
}: PropsWithChildren<{ orderID: string }>) => {
  useOrderFeaturesSyncDriver(orderID);

  const compSequence = useAppSelector(selectCompSequence);
  const rentalCompSequence = useAppSelector(selectRentalCompSequence);
  const compIdsToSync = [...new Set([...compSequence, ...rentalCompSequence])];

  return (
    <>
      <PropertyDataSyncDriver orderID={orderID} id="subject" />
      {compIdsToSync.map((compID) => (
        <PropertyDataSyncDriver key={compID} orderID={orderID} id={compID} />
      ))}
      {children}
    </>
  );
};
